
import { IChuongTrinhDaoTaoChiTietActionTypes } from "../../action-types/ctdt/IChuongTrinhDaoTaoChiTietActionTypes";
import { IChuongTrinhDaoTaoChiTietReducer } from "../../reducer-model/ctdt/IChuongTrinhDaoTaoChiTietReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IChuongTrinhDaoTaoChiTietReducer = {
    chuongTrinhDaoTaos: []
};
export const chuongTrinhDaoTaoChiTietReducer = (
    state: IChuongTrinhDaoTaoChiTietReducer = iniState,
    action: IChuongTrinhDaoTaoChiTietActionTypes
): IChuongTrinhDaoTaoChiTietReducer => {
    switch (action.type) {
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_INI_START":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos, [action.payload]: {
                        id_dt: action.payload,
                        chuongTrinhDaoTaoChiTiets: [],
                        chuongTrinhDaoTaoRangBuocs: [],
                        status: eReducerStatusBase.is_not_initialization,
                        chuongTrinhDaoTaoNhomTuChons: [],
                        focusedTab: "mon-hoc",
                        selectedIds: []
                    }
                }
            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_LOAD_BY_CTDT_START":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload]: {
                        ...state.chuongTrinhDaoTaos[action.payload],
                        status: eReducerStatusBase.is_loading
                    }

                }
            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_LOAD_BY_CTDT_SUCCESS":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        status: eReducerStatusBase.is_completed,
                        chuongTrinhDaoTaoChiTiets: action.payload.data.chuongTrinhDaoTaoChiTiets,
                        chuongTrinhDaoTaoRangBuocs: action.payload.data.chuongTrinhDaoTaoRangBuocs,
                        chuongTrinhDaoTaoNhomTuChons: action.payload.data.chuongTrinhDaoTaoNhomTuChons,
                    }
                }

            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_LOAD_BY_CTDT_ERROR":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        status: eReducerStatusBase.is_completed,
                    }
                }

            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_CHANGE_FOCUSED_TAB":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        focusedTab: action.payload.data
                    }
                }

            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_UPDATE_NHOMTUCHON_CONFIG_START":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        status: eReducerStatusBase.is_saving,
                    }
                }

            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_UPDATE_NHOMTUCHON_CONFIG_SUCCESS":
            return {
                ...state,
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        chuongTrinhDaoTaoNhomTuChons: [
                            ...state.chuongTrinhDaoTaos[action.payload.id_dt].chuongTrinhDaoTaoNhomTuChons.filter(x => x.id !== action.payload.data.id),
                            action.payload.data
                        ]
                    }
                }

            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_UPDATE_NHOMTUCHON_CONFIG_ERROR":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        status: eReducerStatusBase.is_completed,
                    }
                }

            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_UPDATE_START":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        status: eReducerStatusBase.is_saving,
                    }
                }

            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_UPDATE_SUCCESS":
            debugger
            let updatedsChuongTrinhDaoTaoChiTiets = [...state.chuongTrinhDaoTaos[action.payload.id_dt].chuongTrinhDaoTaoChiTiets];
            action.payload.data.forEach((newData) => {
                const id_dt_mon = newData.id_dt_mon;
                const index = updatedsChuongTrinhDaoTaoChiTiets.findIndex(s => s.id_dt_mon === id_dt_mon);
                if (index !== -1) {
                    updatedsChuongTrinhDaoTaoChiTiets[index] = { ...updatedsChuongTrinhDaoTaoChiTiets[index], ...newData };
                }
            });
            const newState = {
                ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                status: eReducerStatusBase.is_completed,
                chuongTrinhDaoTaoChiTiets: updatedsChuongTrinhDaoTaoChiTiets,
            }

            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: newState
                }

            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_UPDATE_ERROR":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        status: eReducerStatusBase.is_completed,
                    }
                }

            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_DELETE_START":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        status: eReducerStatusBase.is_deleting,
                    }
                }

            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_DELETE_SUCCESS":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        status: eReducerStatusBase.is_need_reload,
                    }
                }

            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_DELETE_ERROR":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        status: eReducerStatusBase.is_completed,
                    }
                }

            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_ADD_START":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        status: eReducerStatusBase.is_saving,
                    }
                }

            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_ADD_SUCCESS":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        status: eReducerStatusBase.is_need_reload,
                    }
                }

            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_ADD_ERROR":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        status: eReducerStatusBase.is_completed,
                    }
                }
            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_CHANGE_RANGBUOC_EDIT_MODAL":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        rangBuocEditModal: action.payload.data,
                    }
                }

            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_SAVE_RANGBUOC_START":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        status: eReducerStatusBase.is_saving
                    }
                }

            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_SAVE_RANGBUOC_SUCCESS":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        status: eReducerStatusBase.is_need_reload,
                        // rangBuocEditModal: {
                        //     ...state.chuongTrinhDaoTaos[action.payload.id_dt].rangBuocEditModal,
                        //     isOpen: false
                        // }
                    }
                }

            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_SAVE_RANGBUOC_ERROR":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        status: eReducerStatusBase.is_completed
                    }
                }

            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_DELETE_RANGBUOC_START":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        status: eReducerStatusBase.is_deleting
                    }
                }

            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_DELETE_RANGBUOC_SUCCESS":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        status: eReducerStatusBase.is_need_reload,

                    }
                }

            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_DELETE_RANGBUOC_ERROR":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        status: eReducerStatusBase.is_completed
                    }
                }

            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_CHANGE_ADDLOP_MODAL":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        addLopModal: action.payload.data
                    }
                }

            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_CHANGE_SELECTED":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        selectedIds: action.payload.data
                    }
                }
            };
        // LT_VB2 cascade — saga dispatch action này 1 lần/sibling sau BatchResult.
        // Replace nguyên array chuongTrinhDaoTaoChiTiets, giữ nguyên rangBuocs/nhomTuChons.
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_SYNC_SIBLING_CHITIETS": {
            const existing = state.chuongTrinhDaoTaos[action.payload.id_dt];
            // Sibling state có thể chưa được khởi tạo (user chưa từng switch sang nó).
            // Tạo entry mới với defaults nếu thiếu — tránh undefined khi user switch sang sibling lần đầu.
            const baseSibling = existing ?? {
                id_dt: action.payload.id_dt,
                chuongTrinhDaoTaoChiTiets: [],
                chuongTrinhDaoTaoRangBuocs: [],
                chuongTrinhDaoTaoNhomTuChons: [],
                status: eReducerStatusBase.is_completed,
                focusedTab: "mon-hoc" as const,
                selectedIds: []
            };
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...baseSibling,
                        chuongTrinhDaoTaoChiTiets: action.payload.data,
                    }
                }
            };
        }
        default:
            return state;
    }
};
